import React from 'react';
import SellerAssistantPanel from '../../../../components/SellerAssistant/SellerAssistantPanel';
import './SellerAssistantPage.css';

function SellerAssistantPage() {
  return (
    <div className="seller-assistant-page-wrap">
      <SellerAssistantPanel variant="page" />
    </div>
  );
}

export default SellerAssistantPage;
